import React from "react";

type LoaderProps = {
  size?: number; // px
  strokeWidth?: number; // px
  label?: string;
  className?: string;
};

export function Loader({
  size = 24,
  strokeWidth = 3,
  label,
  className,
}: LoaderProps) {
  const border = `${strokeWidth}px`;
  const dim = `${size}px`;
  return (
    <div
      className={`flex items-center justify-center gap-3 ${className || ""}`}
    >
      <div
        className="rounded-full animate-spin"
        style={{
          width: dim,
          height: dim,
          borderWidth: border,
          borderStyle: "solid",
          borderColor: "rgba(0,0,0,0.15)",
          borderTopColor: "#000000",
        }}
      />
      {label && <span className="text-sm text-gray-600">{label}</span>}
    </div>
  );
}

type OverlayProps = {
  label?: string;
};

export function LoaderOverlay({ label = "Cargando…" }: OverlayProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <Loader size={32} strokeWidth={4} />
        <span className="text-sm text-gray-700">{label}</span>
      </div>
    </div>
  );
}
